// src/components/pages/Pessoa/modules/usePessoaJuridicaModule.js

import { useEffect, useState, useCallback } from 'react';

import * as DataListAPI from '../../../../api/dataList';

function createJuridicaDraft(pessoaId = null) {
    return {
        pessoaId: pessoaId || null,
        razaoSocial: '',
        nomeFantasia: '',
        abertura: '',
        tipo: 'MATRIZ',
        ramoAtividade: 'Industria',
        socioId: null,
        Socio: {},
    };
}

export function usePessoaJuridicaModule({ pessoaId, pessoaJuridica, empresaId, setDadosPai }) {
    const [dados, setDados] = useState(createJuridicaDraft(pessoaId));
    const [socio, setSocio] = useState({ descricao: '' });
    const [optionsSocio, setOptionsSocio] = useState([]);

    const consultarPessoas = useCallback(
        async (filtro) => {
            if (!filtro) {
                setOptionsSocio([]);
                return;
            }

            try {
                const result = await DataListAPI.dataListPessoaFisica(empresaId, filtro);

                setOptionsSocio(result || []);
            } catch (error) {
                console.error(error);
                setOptionsSocio([]);
            }
        },
        [empresaId]
    );

    useEffect(() => {
        if (pessoaJuridica) {
            setDados({
                pessoaId: pessoaJuridica.pessoaId || pessoaId,
                razaoSocial: pessoaJuridica.razaoSocial || '',
                nomeFantasia: pessoaJuridica.nomeFantasia || '',
                abertura: pessoaJuridica.abertura || '',
                ultima_atualizacao: pessoaJuridica.ultima_atualizacao || '',
                tipo: pessoaJuridica.tipo || 'MATRIZ',
                ramoAtividade: pessoaJuridica.ramoAtividade || 'Industria',
                socioId: pessoaJuridica.socioId || null,
            });

            setSocio({
                descricao: pessoaJuridica?.Socio?.descricao || '',
            });

            if (pessoaJuridica?.Socio) {
                setOptionsSocio([pessoaJuridica.Socio]);
            }
        } else {
            setDados(createJuridicaDraft(pessoaId));
            setSocio({ descricao: '' });
            setOptionsSocio([]);
        }
    }, [pessoaJuridica, pessoaId]);

    function change(e) {
        const { name, value, options, selectedIndex } = e.target;
        const field = name.split('.')[1];

        let newValue = value;

        if (field === 'tipo' || field === 'ramoAtividade') {
            newValue = options?.[selectedIndex]?.text || value;
        }

        if (field === 'Socio') {
            setSocio({ descricao: value });

            consultarPessoas(value);

            const selected = optionsSocio.find((opt) => opt.descricao === value);

            const socioId = selected?.id ?? null;

            setDados((prev) => ({
                ...prev,
                socioId,
            }));

            // 🔥 ATUALIZA O PAI
            setDadosPai((prev) => ({
                ...prev,
                pessoaJuridica: {
                    ...(prev.pessoaJuridica || {}),
                    socioId,
                },
            }));

            return;
        }

        // estado local
        setDados((prev) => ({
            ...prev,
            [field]: newValue,
        }));

        // 🔥 ESTADO PRINCIPAL (AQUI ESTAVA O BUG)
        setDadosPai((prev) => ({
            ...prev,
            pessoaJuridica: {
                ...(prev.pessoaJuridica || {}),
                [field]: newValue,
            },
        }));
    }

    return {
        state: {
            dados,
            socio,
            optionsSocio,
        },
        actions: {
            change,
            setDados,
            setSocio,
            setOptionsSocio,
        },
    };
}
